module.exports = __webpack_public_path__ + "static/media/conf-app4.7abf7a5f.png";